import { styled } from '@mui/material/styles';

export const SessionLoading = styled('div')(({ theme }) => ({
	minHeight: '100vh',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	color: theme.palette.text.secondary,
}));
